import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CustomAlert from "../../shared/CustemAlert";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API;

export default function Add({ increment, counter }) {
  const [title, setTitle] = useState(""); // useState hook
  const [error, setError] = useState(false);
  const [isAdded, SetIsAdded] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  // handle change event
  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    setTitle(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();

    const postData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "jobs/hakalareason/",
          {
            title: title.trim(),
          },
          {
            signal: controller.signal,
          }
        );
        setTitle("");
        SetIsAdded(true);
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    postData();
    setTitle("");
    setError(false);
  };
  // render

  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3 border  ">
          <div className="card-header">
            <h2>סיבות להקלה</h2>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  <div className="form-group">
                    <label htmlFor="title">סיבה</label>
                    <textarea
                      style={{ minWidth: "400px" }}
                      name="title"
                      value={title}
                      onChange={handleChange}
                      className="form-control"
                      id="title"
                      placeholder="תקליד סיבה להוספה"
                    />
                  </div>

                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף סיבה חדשה
                  </button>
                </form>
              </Col>
            </Row>

            {isAdded && (
              <CustomAlert
                setShow={SetIsAdded}
                alertHeader={title}
                alertBody="הסיבה נוספה בהצלחה"
              />
            )}
          </div>
        </div>
      </center>
    </div>
  );
}
